<template>
  <v-form v-model='valid' ref='form' lazy-validation>
    <v-container>
      <v-layout align-center justify-end v-if='!modificar'>
        <v-btn fab color="primary" class="botonEdit" @click='modificarDatos()'>
          <v-icon>edit</v-icon>
        </v-btn>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-select
            :no-data-text="$t('comun.sin_datos')"
            v-model='motivoDeclaracion'
            :items="motivoDeclaracionItems"
            item-text='motdec_descripcion'
            item-value='motdec_codigo'
            label='Motivo de la Declaración*'
            @change="obtenerDescripcionMotivoDeclaracion()"
            :rules="dRules"
            required
            :disabled='!modificar'
          ></v-select>
        </v-flex>
        <v-flex xs6 sm6 md6 v-if='oculatarCalendario'>
            <global-date-input-picker
              v-model="date" :hint="'Formato DD/MM/AAAA'" :disabled='!modificar' :rules="motivoDeclaracion === 7 ? dRules : true" label="Fecha de la Declaración a Rectificar*">
            </global-date-input-picker>  
          </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm12 md12 v-show='this.motivoDeclaracion===7'>
          <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
              <v-textarea
                @change="observacionesRectificacion = $util.sanitiza(observacionesRectificacion)"
                v-on='on'
                v-model="observacionesRectificacion"
                :label="$t('datos_generales.observacion')"
                maxlength='250'
                :counter='250'
                hint='Máximo 250 caracteres.'
                persistent-hint
                :disabled='!modificar'
                :rules="motivoDeclaracion!==7 ? textRules : $validate(['text_area_required'])"
                required
                rows="1"
                auto-grow
              ></v-textarea>
            </template>
            <span>Si desea modificar el motivo de la declaración, Justifique la rectificación y el nuevo motivo.</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <v-layout> 
        <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-show='modificar' v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>{{this.motdecComentario}}</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
        <v-flex xs12 sm12 md12 v-show='modificar' class="decretos">
          <v-alert align='justify' :value='!!motivoDeclaracion' type='info' outline>{{this.motdecComentario}}</v-alert>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md2>
          <p>Declarar Como:</p>
        </v-flex>
        <v-flex xs12 md10>
            <!-- <p>{{ declarar_como || 'null' }}</p> -->
            <v-radio-group 
              v-model='declararComo' 
              :mandatory='false' 
              row 
              :disabled='!modificar'
              @change='pais="", localidad=""'
              :rules="dRules"
              required
              >
              <v-radio label='Servidor Público en Bolivia' value='1'></v-radio>
              <v-radio label='Servidor Público en el Exterior' value='2'></v-radio>
            </v-radio-group>
        </v-flex>
      </v-layout>
      <v-layout wrap v-if="declararComo === '1' && tipo_usuario === 'usuario_externo'">
        <v-flex sm6 md6>
         <v-autocomplete 
         :disabled='!modificar' 
         :rules="dRules" 
         :no-data-text='this.dato' 
         v-model='codDepartamento.dep_codigo' 
         :items="itemsDep" item-text="dep_descripcion" 
         item-value="dep_codigo" label="Departamento donde Presentará su Declaración Jurada*"></v-autocomplete>
         </v-flex>
      </v-layout>
      <v-layout>
        <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-show='modificar' v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>{{$t('decretos.dec_sup_1233')}}</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
        <v-flex xs12 md12 class="decretos">
          <v-alert align='justify'
            :value='modificar'
            type='info'
            outline
          >{{$t('decretos.dec_sup_1233')}}</v-alert>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md6 v-if="declararComo === '1'">
          <p align='justify'>El Lugar Donde Reside el Declarante ¿Es Capital de Departamento?</p>
        </v-flex>
        <v-flex xs12 md4 v-if="declararComo === '1'">
            <v-radio-group v-model='esCapital' :mandatory='true' :rules="dRules" required row :disabled='!modificar'>
              <v-radio label='Sí' value='1'></v-radio>
              <v-radio label='No' value='2'></v-radio>
            </v-radio-group>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm12 md6 v-if="declararComo === '1'">
          <v-text-field
            v-model='pais2'
            :rules='dRules'
            label='País de Residencia del Declarante*'
            required
            :disabled='!modificar'
            box
            readonly
          ></v-text-field>
        </v-flex>
         <v-flex xs12 sm12 md6 v-if="declararComo === '2'">
        <v-autocomplete
        :no-data-text="$t('comun.sin_datos')"
            v-model='pais'
            :items='itemsPaises'
            item-text='pai_descripcion'
            item-value='pai_codigo'
            label='País de Residencia del Declarante*'
            :rules='dRules'
            required
            :disabled='!modificar'
            maxlength='50'
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            v-model='localidad'
            :rules='dRules'
            maxlength='50'
            label='Localidad de Residencia del Declarante*'
            required
            :disabled='!modificar'
            @keyup="localidad = localidad ? localidad.replace(/[!°¬#$%&=?¿¡{}]/g, ''):''"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-show='modificar' v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>{{$t('decretos.dec_sup_1233_3')}}</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
        <v-flex xs12 md12 class="decretos">
          <v-alert align='justify'
            :value='modificar'
            type='info'
            outline
          >{{$t('decretos.dec_sup_1233_3')}}</v-alert>
        </v-flex>
      </v-layout>
      <br>
      <v-layout wrap>
        <v-flex sm12 md12>
          <v-subheader><p class='plomo--text'>Por favor llene los campos requeridos*</p></v-subheader>
        </v-flex>
      </v-layout>
      <v-btn color='primary' @click='modificarDatos()' v-show='!modificar'>
        <v-icon>create</v-icon>&nbsp;Modificar
      </v-btn>
      <v-btn color='primary' :loading="loadingButton" @click='modificarDeclaracion' v-show='modificar'>
        <v-icon>save</v-icon>&nbsp;Guardar
      </v-btn>
      <v-btn color='error' @click='cancelarAction' v-show='modificar'>
        <v-icon>cancel</v-icon>&nbsp;Cancelar
      </v-btn>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
var format = require('date-format');
export default {
  mixins: [ Parametricas, validate ],
  async created () {
    let banderaDeclaraciones = this.$storage.get('dec');
    // let datos = [];
    // await this.$service.get(`djbr_registro/obtieneFinalizados`, {}).then(response => {
    //   if (response.error_existente !== 1) {
    //     datos = response;
    //   }
    // });
    let token = this.$util.parseJwt(this.$storage.get('token'));
    this.tipo_usuario = token.tipo;
    if (this.motivoDeclaracionItems.length === 0) {
      this.obtenerMotivoDeclaracionParametrica().then(respuesta => {
        let motivoDeclaracionItemsInicio = respuesta.datos;
        let i = 0;
        motivoDeclaracionItemsInicio.forEach(element => {
          if (element.motdec_codigo === 7 && banderaDeclaraciones === '1') {
            motivoDeclaracionItemsInicio.splice(i, 1);
          }
          i++;
        });
        this.motivoDeclaracionItems = motivoDeclaracionItemsInicio;
        this.obtenerDescripcionMotivoDeclaracion();
      });
    }
    if (this.itemsPaises.length === 0) {
      this.obtenerPaisesParametrica().then(respuesta => {
        this.itemsPaises = respuesta.datos;
      });
    }
    if (this.itemsDep.length === 0) {
      this.cargarDepartamentos();
    }
    this.obtenerDatos();
  },
  mounted () {
    this.$root.$on('clickedGuardarDatosDeclaracion', () => {
      this.modificarDeclaracion();
    });
  },
  data: () => ({
    loadingButton: false,
    codDepartamento: { dep_codigo: 0, dep_descripcion: '' },
    itemsDep: [],
    dato: 'No hay datos disponibles',
    tipo_usuario: '',
    menu: false,
    modificar: false,
    declararComo: null,
    esCapital: null,
    datosDeclaracion: {},
    valid: false,
    pais: '',
    itemsPaises: [],
    localidad: '',
    motivoDeclaracion: 0,
    motivoDeclaracionItems: [],
    motdecComentario: '',
    declaracion_departamento: null,
    oculatarCalendario: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [],
    dateRulesF: [v => ((v || '').length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos'],
    // date: new Date().toISOString().substr(0, 10),
    codEstcivil: 0,
    domDeclaracion: '',
    dirDeclaracion: '',
    fechaDeclaracion: new Date().toISOString().substr(0, 10),
    codPersona: 0,
    mensajeValidacion: 0,
    validacionTexto: false,
    perdecCodigo: 0,
    codDeclaracion: '',
    fechaActual: new Date().toISOString().substr(0, 10),
    date: '',
    pais2: 'BOLIVIA',
    observacionesRectificacion: ''
  }),
  methods: {
    cargarDepartamentos () {
      this.$service
        .get(`departamentos`, {})
        .then(response => {
          if (response) {
            this.itemsDep = response;
          }
        });
    },
    obtenerDatos () {
      this.$service.get(`djbr_registro/declaracion_jurada`, {}).then(response => {
        if (response) {
          this.mensajeValidacion = response.err_existente;
          this.perdecCodigo = response.perdec_codigo;
          if (response.perdec_codigo === -1) {
            this.modificar = true;
            // let ctrl = this.$storage.get('ctrl');
            // ctrl.datos_generales.datos_declaracion = true;
            // this.$storage.set('ctrl', ctrl);
          }
          this.setearDatos(response);
          this.motivoDeclaracion = response.motdec_codigo;
        }
      });
    },
    setearDatos (response) {
      this.motivoDeclaracion = response.motdec_codigo;
      this.motdecComentario = response.motdec_comentario.replace('<B>', '').replace('</B>', '');
      this.declararComo = response.datcom_nacional_extranjero.toString();
      this.esCapital = response.decjur_ciudad_capital.toString();
      this.pais = response.pai_codigo;
      this.$storage.set('codigoPais', this.pais);
      this.localidad = response.decjur_lugar_declaracion;
      this.observacionesRectificacion = response.decjur_direccion_laboral;
      if (response.dep_codigo === -1) {
        this.codDepartamento.dep_codigo = 2;
      } else {
        this.codDepartamento.dep_codigo = response.dep_codigo;
      }
      if (response.estciv_codigo === -1) {
        this.codEstcivil = 0;
      } else {
        this.codEstcivil = response.estciv_codigo;
      }
      this.domDeclaracion = response.decjur_domicilio_documento;
      this.dirDeclaracion = response.decjur_direccion_laboral;
      this.fechaDeclaracion = response.decjur_fecha_declaracion;
      this.codDeclaracion = response.decjur_codigo;
      if (this.motivoDeclaracion === 7) {
        const [year, month, day] = this.fechaDeclaracion.split('-');
        this.date = `${day}/${month}/${year}`;
        this.oculatarCalendario = true;
      }
    },
    async obtenerDescripcionMotivoDeclaracion () {
      this.motivoDeclaracionItems.forEach(element => {
        if (this.motivoDeclaracion === element.motdec_codigo) {
          this.motdecComentario = element.motdec_comentario.replace('<B>', '').replace('</B>', '');
          this.oculatarCalendario = false;
          if (element.motdec_codigo === 7) {
            this.oculatarCalendario = true;
          }
        }
      });
    },
    modificarDeclaracion () {
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        if (this.declararComo === '2') {
          this.esCapital = '2';
          this.codDepartamento.dep_codigo = 2;
        } else {
          this.pais = 'BOL';
        }
        if (this.motivoDeclaracion === 7) {
          if (Date.parse(this.$util.formatDateYYYYMMDD(this.date)) <= Date.parse(this.fechaActual)) {
            let dateParts = this.date.split('/');
            this.fechaDeclaracion = format.asString('yyyy-MM-dd', new Date(`${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`));
            let params = {
              cod_declaracion: this.codDeclaracion,
              cod_pais: this.pais,
              ciudad_capital: this.esCapital,
              localidad: this.localidad,
              cod_departamento: this.codDepartamento.dep_codigo,
              cod_motivo: this.motivoDeclaracion,
              fecha_declaracion: this.fechaDeclaracion,
              declara_nacional_extranjero: this.declararComo,
              descripcion_rectificacion: this.observacionesRectificacion
            };
            this.$service
            .put(`djbr_registro/declaracion_jurada`, params)
            .then(response => {
              if (response) {
                if (response.err_existente === 0) {
                  this.loadingButton = false;
                  this.$message['success'](response.err_mensaje);
                  this.$storage.set('codigoPais', this.pais);
                  this.disabledForm = true;
                  this.modificar = !this.modificar;
                  this.datosDeclaracionEmmit();
                  let ctrl = this.$storage.get('ctrl');
                  ctrl.datos_generales.datos_declaracion = false;
                  this.$storage.set('ctrl', ctrl);
                } else {
                  this.loadingButton = false;
                  this.$message['error'](response.err_mensaje);
                  this.obtenerDatos();
                }
              } else {
                this.loadingButton = false;
              }
            })
            .catch(e => {
              console.log(e);
              this.loadingButton = false;
            });
          } else {
            this.$message['warning']('La fecha de rectificación no puede estar vacia y no debe ser futura');
            this.loadingButton = false;
          }
        } else {
          this.fechaDeclaracion = format.asString('yyyy-MM-dd', new Date());
          let params = {
            cod_declaracion: this.codDeclaracion,
            cod_pais: this.pais,
            ciudad_capital: this.esCapital,
            localidad: this.localidad,
            cod_departamento: this.codDepartamento.dep_codigo,
            cod_motivo: this.motivoDeclaracion,
            fecha_declaracion: this.fechaDeclaracion,
            declara_nacional_extranjero: this.declararComo,
            descripcion_rectificacion: this.observacionesRectificacion
          };
          this.$service
          .put(`djbr_registro/declaracion_jurada`, params)
          .then(response => {
            if (response) {
              if (response.err_existente === 0) {
                this.loadingButton = false;
                this.$message['success'](response.err_mensaje);
                this.$storage.set('codigoPais', this.pais);
                this.disabledForm = true;
                this.modificar = !this.modificar;
                this.datosDeclaracionEmmit();
                let ctrl = this.$storage.get('ctrl');
                ctrl.datos_generales.datos_declaracion = false;
                this.$storage.set('ctrl', ctrl);
              } else {
                this.loadingButton = false;
                this.$message['error'](response.err_mensaje);
                this.obtenerDatos();
              }
            } else {
              this.loadingButton = false;
            }
          })
          .catch(e => {
            console.log(e);
            this.loadingButton = false;
          });
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos.');
      }
    },
    cancelarAction () {
      this.modificar = !this.modificar;
      this.oculatarCalendario = false;
      this.obtenerDatos();
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.datos_declaracion = false;
      this.$storage.set('ctrl', ctrl);
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    modificarDatos () {
      this.modificar = !this.modificar;
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.datos_declaracion = true;
      this.$storage.set('ctrl', ctrl);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datosGenerales/datosDeclaracion.vue